import React, {ReactElement, ReactNode} from 'react';
import {cx} from '@emotion/css';
import Sidebar from './Sidebar/Sidebar';
import {useDevice, Device} from '../../../../RootProvider/DeviceContext';
import PartnerLogo, {Props as PartnerLogoProps} from '../../PartnerLogo/PartnerLogo';
import LayoutSectionCircles from './Circles/LayoutSectionCircles';
import {LayoutCircleConfig} from './Circles/LayoutSectionCircles.types';
import {LayoutBackground, SidebarPropsExtended} from './LayoutSection.types';
import styles from './LayoutSection.styles';

export interface LayoutSectionProps {
  id?: string;
  children?: ReactNode;
  circles?: LayoutCircleConfig;
  className?: string;
  innerClassName?: string;
  partner?: PartnerLogoProps;
  sidebar?: SidebarPropsExtended;
  slim?: boolean;
  type?: LayoutBackground;
}

function LayoutSection({
  id,
  children,
  circles,
  className,
  innerClassName,
  partner,
  sidebar,
  slim,
  type,
}: LayoutSectionProps): ReactElement {
  const isDesktop = useDevice() === Device.DESKTOP;

  return (
    // using cx for the classname here breaks sibling selectors hence use of string literal
    <section className={`${styles.container(type)} ${className || ''}`.trim()} data-testid="ui.layoutSection" id={id}>
      <div className={cx(styles.main(slim, sidebar), 'layoutSection__main')}>
        {circles && <LayoutSectionCircles config={circles} />}
        <div className={cx(styles.mainInner(sidebar), innerClassName)}>
          {!isDesktop && partner && (
            <div className={cx(styles.partner)}>
              <PartnerLogo name={partner.name} logoUrl={partner.logoUrl} />
            </div>
          )}
          {children}
        </div>
      </div>
      {sidebar && (
        <div className={cx(styles.sidebarWrap(sidebar.sidebarVariant))}>
          <div className={cx(styles.sidebarWrapInner(sidebar.sidebarVariant))}>
            <Sidebar
              advantages={sidebar.advantages}
              hideAdvantages={sidebar.hideAdvantages}
              partner={partner}
              sideBarBottomComponent={sidebar.sideBarBottomComponent}
            />
          </div>
        </div>
      )}
    </section>
  );
}

export default LayoutSection;
